import {
  CREATE_WORK,
  CREATE_WORK_FAILURE,
  CREATE_WORK_SUCCESS,
  DELETE_WORK,
  DELETE_WORK_FAILURE,
  DELETE_WORK_SUCCESS,
  GET_WORKS,
  GET_WORKS_FAILURE,
  GET_WORKS_SUCCESS,
  GET_SINGLE_WORK,
  GET_SINGLE_WORK_FAILURE,
  GET_SINGLE_WORK_SUCCESS,
  UPDATE_WORK,
  UPDATE_WORK_FAILURE,
  UPDATE_WORK_SUCCESS,
} from "./actionTypes";

const initialState = {
  works: [],
  singleWork: {},
  isLoggedIn: null,
  loading: false,
  error: "",
};

const works = (state = initialState, action) => {
  switch (action.type) {
    case GET_WORKS:
      return {
        ...state,
        loading: true,
      };

    case GET_WORKS_SUCCESS:
      return {
        ...state,
        works: action.payload,
        loading: false,
      };

    case GET_WORKS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case GET_SINGLE_WORK:
      return {
        ...state,
        loading: true,
      };

    case GET_SINGLE_WORK_SUCCESS:
      return {
        ...state,
        singleWork: action.payload,
        loading: false,
      };

    case GET_SINGLE_WORK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case CREATE_WORK:
      return {
        ...state,
        loading: true,
      };

    case CREATE_WORK_SUCCESS:
      return {
        ...state,
        works: [...state.works, action.payload],
        loading: false,
      };

    case CREATE_WORK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case UPDATE_WORK:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_WORK_SUCCESS:
      return {
        ...state,
        works: state.works.map((work) =>
          work._id === action.payload._id ? action.payload : work
        ),
        loading: false,
      };

    case UPDATE_WORK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case DELETE_WORK:
      return {
        ...state,
        loading: true,
      };

    case DELETE_WORK_SUCCESS:
      return {
        ...state,
        works: state.works.filter((work) => work._id !== action.payload?.id),
        loading: false,
      };

    case DELETE_WORK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default works;
